import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import KeyValue from '../../../Common/KeyValue'
import { useTranslation } from 'react-i18next'

interface Sections {
    [sectionName: string]: {
        [key: string]: string | number | null
    }
}

interface SensorReadingsBoxProps {
    header: string
    sections: Sections
}

const SensorReadingsBox: React.FC<SensorReadingsBoxProps> = ({
    header,
    sections,
}) => {
    const { t } = useTranslation()
    // Get section data in the desired order
    const orderedSections = useMemo(
        () =>
            [
                'General Statistics',
                'High Threshold',
                'Low Threshold',
                'High/Low Threshold',
            ].map((sectionName) => ({
                name: sectionName,
                keyValues: sections[sectionName],
            })),
        [sections],
    )

    const renderSection = (
        sectionName: string,
        keyValues?: { [key: string]: string | number | null },
    ) => {
        if (!keyValues) return null
        return (
            <Box key={sectionName}>
                <Box
                    sx={{
                        background: '#DCECF9',
                        padding: '15px 15px',
                        borderRadius: '5px 5px 0px 0px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography fontWeight="600">{t(sectionName)}</Typography>
                </Box>
                <Box
                    sx={{
                        padding: '10px 20px',
                        background: '#edf2f5',
                        borderRadius: '0px 0px 5px 5px',
                    }}
                >
                    {Object.entries(keyValues).map(([key, value]) => (
                        <Box sx={{ marginBottom: '15px' }} key={key}>
                            <KeyValue
                                key={key}
                                name={t(key)}
                                value={value ?? 'N/A'}
                                keyWidth="40%"
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        )
    }

    return (
        <Box marginBottom="20px">
            <Box
                sx={{
                    marginBottom: '10px',
                    // background: '#DCECF9',
                    // padding: '10px 15px',
                    // borderRadius: '5px 5px 0px 0px',
                    // display: 'flex',
                    // alignItems: 'center',
                    // justifyContent: 'space-between',
                }}
            >
                <Typography variant="h6">{t(header)}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    background: '#F5FBFF',
                    gap: '20px',
                }}
            >
                {/* Left side: General Statistics */}
                <Box sx={{ flex: 1 }}>
                    {renderSection(
                        orderedSections[0].name,
                        orderedSections[0].keyValues,
                    )}
                </Box>

                {/* Right side: Time Above High & Time Below Low stacked vertically */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}
                >
                    {orderedSections
                        .slice(1)
                        .map((section) =>
                            renderSection(section.name, section.keyValues),
                        )}
                </Box>
            </Box>
        </Box>
    )
}

export default SensorReadingsBox
